import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, isRef as _isRef, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "cart-top-nav-background"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import cartUtils from '../cartUtils';
import { useLess } from '@/models/hooks';
import imageLink from '@/configs/imageLink';
import { useRouter, useRoute } from 'vue-router';
import { isLoginAuthenticated } from '@/utils/common';
import SelectAddressPopup from '@/components/popup/SelectAddressPop.vue';
export default {
  __name: 'CartTopNav',
  props: ['cptPopupHeight', 'isLoadingSelectAddressPopup'],
  setup(__props) {
    useLess('views/cart/components/CartTopNav.less');
    const {
      VECTOR,
      ICON_BACK,
      RIGHT_ARROW_BLACK
    } = imageLink;
    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    /**
     * **/

    const isShowSelectAddressPopup = ref(false);

    // Shopping cart data processing function
    const {
      addressInfo,
      allProductData,
      isManagement
    } = cartUtils.cartState;
    const onManagement = () => {
      isManagement.value = !isManagement.value;
    };

    /**
     * If rootPage exists, hide the return icon
     * If there is no rootPage, the return icon is displayed
     * **/
    const rootPage = ref(false);
    const toAddress = async () => {
      if (!(await isLoginAuthenticated())) return;
      isShowSelectAddressPopup.value = true;
    };
    const onBack = () => {
      if (!rootPage.value) {
        router.go(-1);
      }
    };

    // Set the location of the navigation header based on the value in the store
    const cptTopNavPaddingTop = computed(() => {
      var _ref, _store$state$navigato;
      return (_ref = `${(_store$state$navigato = store.state.navigator.agentData) === null || _store$state$navigato === void 0 ? void 0 : _store$state$navigato.top}px`) !== null && _ref !== void 0 ? _ref : `0px`;
    });
    watch(() => {
      var _route$query;
      return (_route$query = route.query) === null || _route$query === void 0 ? void 0 : _route$query.rootPage;
    }, () => {
      var _route$query2;
      if ((_route$query2 = route.query) !== null && _route$query2 !== void 0 && _route$query2.rootPage) {
        rootPage.value = true;
      } else {
        rootPage.value = false;
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      var _unref2, _unref3;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: "cart-top-nav",
        style: _normalizeStyle({
          paddingTop: cptTopNavPaddingTop.value
        })
      }, [_createElementVNode("div", {
        class: _normalizeClass(["go-back", {
          'no-back-icon': rootPage.value
        }]),
        onClick: onBack
      }, [!rootPage.value ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: _unref(ICON_BACK),
        alt: ""
      }, null, 8, _hoisted_2)) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(_ctx.$t('modules.cart.CART_NAME')) + " ", 1), _createElementVNode("span", null, "(" + _toDisplayString(_unref(allProductData).length) + ")", 1)], 2), _createElementVNode("div", {
        onClick: toAddress,
        class: "address"
      }, [_createElementVNode("img", {
        src: _unref(VECTOR),
        alt: ""
      }, null, 8, _hoisted_3), _createElementVNode("p", {
        class: _normalizeClass(["address-text", {
          'empty-prompt': !((_unref2 = _unref(addressInfo)) !== null && _unref2 !== void 0 && _unref2.street)
        }])
      }, _toDisplayString(((_unref3 = _unref(addressInfo)) === null || _unref3 === void 0 ? void 0 : _unref3.street) || _ctx.$t('modules.cart.PLEASE_ADD_DELIVERY_LOCATION')), 3), _createElementVNode("img", {
        class: "right-arrow",
        src: _unref(RIGHT_ARROW_BLACK),
        alt: ""
      }, null, 8, _hoisted_4)]), _createElementVNode("span", {
        onClick: onManagement,
        class: "management"
      }, _toDisplayString(_unref(isManagement) ? _ctx.$t('button.CLOSE') : _ctx.$t('button.MANAGE')), 1)], 4)]), __props.isLoadingSelectAddressPopup ? (_openBlock(), _createBlock(SelectAddressPopup, {
        key: 0,
        style: _normalizeStyle({
          marginBottom: __props.cptPopupHeight + 'px'
        }),
        selected: _unref(addressInfo),
        "onUpdate:selected": _cache[0] || (_cache[0] = $event => _isRef(addressInfo) ? addressInfo.value = $event : null),
        show: isShowSelectAddressPopup.value,
        "onUpdate:show": _cache[1] || (_cache[1] = $event => isShowSelectAddressPopup.value = $event)
      }, null, 8, ["style", "selected", "show"])) : _createCommentVNode("", true)], 64);
    };
  }
};